export default __webpack_public_path__ + "static/media/SharpGroteskSmBold15.5600f0d5.woff";